import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Categories.css';
import todosImage from '../assets/images/todos.png';
import rollMixtosImage from '../assets/images/roll_mixtos.png';
import polloCrispyImage from '../assets/images/pollo_crispy.png';
import extrasImage from '../assets/images/extras.png';

const Categories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      name: 'TODOS',
      slug: 'todos',
      backgroundColor: '#FFE5D9', // Light peach
      image: todosImage
    },
    {
      id: 2,
      name: 'SUSHI',
      slug: 'rolls-mixtos',
      backgroundColor: '#D4E4F7', // Light blue
      image: rollMixtosImage
    },
    {
      id: 3,
      name: 'POLLO CRISPY',
      slug: 'pollo-crispy',
      backgroundColor: '#FFB4A2', // Coral orange
      image: polloCrispyImage
    },
    {
      id: 4,
      name: 'EXTRAS',
      slug: 'extras',
      backgroundColor: '#E7F6D9',
      image: extrasImage
    }
  ];

  const handleCategoryClick = (slug) => {
    if (slug === 'todos') {
      navigate('/combos');
    } else if (slug === 'extras') {
      navigate('/categorias/extras');
    } else {
      navigate(`/combos/${slug}`);
    }
  };

  return (
    <section className="categories">
      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Inicio</Link>
          <span> / </span>
          <span>CATEGORÍAS</span>
        </div>
        <h1 className="categories-title">CATEGORÍAS</h1>
        <div className="categories-grid">
          {categories.map((category) => (
            <div 
              key={category.id} 
              className="category-card"
              style={{ backgroundColor: category.backgroundColor }}
              onClick={() => handleCategoryClick(category.slug)}
            >
              <div className="category-image-container">
                <img 
                  src={category.image} 
                  alt={category.name}
                  className="category-image"
                />
              </div>
              <h3 className="category-name">{category.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;

